import $ from "jquery";

Drupal.behaviors.siwertellIsFindOffice = {
  attach: function (context) {
    const $isFoundOfficeWrapper = $(".office-wrapper--is-find-office");
    const $officeAddressContent = $(".office-address__content");
    const $officeAddressTitle = $(".office-address__title");

    if ($isFoundOfficeWrapper) {
      $officeAddressContent.removeClass("office__content-inner--hidden");
      $officeAddressTitle
        .removeClass("office__content-title--closed")
        .addClass("office__content-title--open");
    }
  },
};
